/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AadConnectRequestModel {
  token?: string | null;
}

export interface AadConnectResponseModel {
  isLoggedIn?: boolean;
  message?: string | null;
}

export interface AdminUserModel {
  userTenants?: TenantUserBaseModel[] | null;
  language?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;
  notifyWeeklyAudits?: boolean | null;
  notifyIdleMeasures?: boolean;
  notifyCorrectionManagerUpdate?: boolean | null;
  notifyCorrectionImplementerUpdate?: boolean | null;
  email?: string | null;

  /** @format date-time */
  registrationDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AdminUserModelApiResultSuccess {
  returnValue?: AdminUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AdminUserModelIEnumerableApiResultSuccess {
  returnValue?: AdminUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum AggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
}

export interface AggregationModel {
  predicates?: PredicateDefinition[] | null;
  aggregation?: AggregationEnum;
  aggregationProperty?: string | null;
}

export interface AggregationResponse {
  result?: IActionResult;
}

export interface AggregationResponseApiResultSuccess {
  returnValue?: AggregationResponse;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AiMessage {
  message?: string | null;
}

export enum AiServiceQueueActionEnum {
  AiGeneratePlanItemReport = "AiGeneratePlanItemReport",
}

export interface AiServiceQueueItemModel {
  action?: AiServiceQueueActionEnum;
  isDone?: boolean;

  /** @format date-time */
  doneAt?: string | null;

  /** @format uuid */
  auditId?: string | null;

  /** @format uuid */
  planItemId?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AiServiceQueueItemModelApiResultSuccess {
  returnValue?: AiServiceQueueItemModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AiServiceQueueItemModelIEnumerableApiResultSuccess {
  returnValue?: AiServiceQueueItemModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AiSuggestedQuestion {
  /** @format uuid */
  id?: string | null;

  /** @format int32 */
  index?: number;
  category?: string | null;
  code?: string | null;
  question?: string | null;
  description?: string | null;
  disagreementResponse?: string | null;
  originalQuestion?: string | null;
}

export interface AiSuggestQuestionsRequest {
  generateDescription?: boolean;
  generateDisagreementResponse?: boolean;
  messages?: AiMessage[] | null;
}

export interface AiSuggestQuestionsResponse {
  suggestedCategories?: string[] | null;
  suggestedQuestions?: AiSuggestedQuestion[] | null;
  generateDescription?: boolean;
  generateDisagreementResponse?: boolean;
  messages?: AiMessage[] | null;
}

export interface AiSuggestQuestionsResponseApiResultSuccess {
  returnValue?: AiSuggestQuestionsResponse;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultBase {
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApiResultException {
  message?: string | null;
  stackTrace?: string | null;
  error?: ApiResultException;
}

export interface ApiResultFailed {
  returnValue?: Null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ApplicationUserModel {
  language?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  twoFactorEnabled?: boolean;
  notifyWeeklyAudits?: boolean | null;
  notifyIdleMeasures?: boolean;
  notifyCorrectionManagerUpdate?: boolean | null;
  notifyCorrectionImplementerUpdate?: boolean | null;
  systemUser?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  avatar?: string | null;
  isActive?: boolean;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ApplicationUserModelApiResultSuccess {
  returnValue?: ApplicationUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AuditBasicModel {
  name?: string | null;

  /** @format uuid */
  categoryId?: string | null;
  category?: CategoryBasicModel;
  isActive?: boolean;
  aiGenerated?: boolean | null;

  /** @format uuid */
  ownerId?: string | null;
  owner?: TenantUserBaseModel;
  explanationType?: AuditExplanationTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AuditExplanationModel {
  /** @format uuid */
  auditId?: string;
  explanation?: AuditExplanationTypeEnum;

  /** @format int32 */
  responseValue?: number;
  explanationDescription?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum AuditExplanationTypeEnum {
  None = "None",
  ByCategory = "ByCategory",
  ByAudit = "ByAudit",
  ByQuestionGroup = "ByQuestionGroup",
}

export interface AuditModel {
  instructions?: string | null;
  aiReportInstructions?: string | null;
  useProductGroups?: boolean;
  auditExplanations?: AuditExplanationModel[] | null;
  processSteps?: ProcessStepModel[] | null;
  productGroups?: ProductGroupModel[] | null;
  productGroupProcessSteps?: ProductGroupProcessStepModel[] | null;
  name?: string | null;

  /** @format uuid */
  categoryId?: string | null;
  category?: CategoryBasicModel;
  isActive?: boolean;
  aiGenerated?: boolean | null;

  /** @format uuid */
  ownerId?: string | null;
  owner?: TenantUserBaseModel;
  explanationType?: AuditExplanationTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AuditModelApiResultSuccess {
  returnValue?: AuditModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AuditModelIEnumerableApiResultSuccess {
  returnValue?: AuditModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AuditTimingModel {
  /** @format uuid */
  auditId?: string;

  /** @format uuid */
  groupId?: string;
  group?: GroupBasicModel;

  /** @format double */
  repeatEach?: number | null;
  type?: AuditTimingType;
  repeatFrequency?: RepeatFrequencyEnum;
  onMonday?: boolean;
  onTuesday?: boolean;
  onWednesday?: boolean;
  onThursday?: boolean;
  onFriday?: boolean;
  onSaturday?: boolean;
  onSunday?: boolean;

  /** @format int32 */
  dayOfMonth?: number | null;

  /** @format int32 */
  occurrenceCount?: number | null;

  /** @format date-time */
  planFromDate?: string | null;

  /** @format date-time */
  planToDate?: string | null;
  nextBusinessDayOnHoliday?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  shiftTypeId?: string | null;
  shiftType?: ShiftTypeModel;

  /** @format uuid */
  workplaceId?: string | null;
  workplace?: WorkplaceModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface AuditTimingModelApiResultSuccess {
  returnValue?: AuditTimingModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface AuditTimingModelIEnumerableApiResultSuccess {
  returnValue?: AuditTimingModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum AuditTimingType {
  SingleDay = "SingleDay",
  Interval = "Interval",
}

export interface AvatarUploadModel {
  contentType?: string | null;
  base64?: string | null;
}

export interface AvatarUploadModelApiResultSuccess {
  returnValue?: AvatarUploadModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CategoryBasicModel {
  name?: string | null;
  responseType?: ResponseTypeEnum;
  responseDescriptionType?: ResponseDescriptionTypeEnum;
  useExplanationByCategory?: boolean | null;
  useCommentOnResponse?: boolean | null;
  useNotRatedOption?: boolean | null;
  enforceReasonForNotRatedOption?: boolean | null;
  enforceInstuctionsConfirmation?: boolean | null;
  useMeasureType?: boolean | null;
  useAuditApproval?: boolean | null;
  useAuditApprovalWithNoFindings?: boolean | null;
  aiUseReportGeneration?: boolean;
  measureVerificationUserType?: MeasureVerificationUserTypeEnum;
  planItemCloseType?: PlanItemCloseTypeEnum;
  correctionManagers?: CorrectionManagerModel[] | null;
  responseValues?: ResponseValueModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CategoryModel {
  categoryUsers?: CategoryUserModel[] | null;
  name?: string | null;
  responseType?: ResponseTypeEnum;
  responseDescriptionType?: ResponseDescriptionTypeEnum;
  useExplanationByCategory?: boolean | null;
  useCommentOnResponse?: boolean | null;
  useNotRatedOption?: boolean | null;
  enforceReasonForNotRatedOption?: boolean | null;
  enforceInstuctionsConfirmation?: boolean | null;
  useMeasureType?: boolean | null;
  useAuditApproval?: boolean | null;
  useAuditApprovalWithNoFindings?: boolean | null;
  aiUseReportGeneration?: boolean;
  measureVerificationUserType?: MeasureVerificationUserTypeEnum;
  planItemCloseType?: PlanItemCloseTypeEnum;
  correctionManagers?: CorrectionManagerModel[] | null;
  responseValues?: ResponseValueModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CategoryModelApiResultSuccess {
  returnValue?: CategoryModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CategoryModelIEnumerableApiResultSuccess {
  returnValue?: CategoryModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CategoryUserModel {
  /** @format uuid */
  categoryId?: string;
  category?: CategoryBasicModel;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CategoryUserModelApiResultSuccess {
  returnValue?: CategoryUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CategoryUserModelIEnumerableApiResultSuccess {
  returnValue?: CategoryUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CodebookModel {
  type?: CodebookTypeEnum;
  name?: string | null;
  nameIdentifier?: string | null;

  /** @format int32 */
  position?: number;
  color?: string | null;
  defaultValue?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CodebookModelApiResultSuccess {
  returnValue?: CodebookModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CodebookModelIEnumerableApiResultSuccess {
  returnValue?: CodebookModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

/**
 * @format int32
 */
export type CodebookTypeEnum = number;

export enum ConditionalQueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
}

export interface ConfirmEmailModel {
  /** @format email */
  email: string;
  token?: string | null;
}

export interface ConfirmResetPasswordModel {
  /** @format email */
  email: string;
  token?: string | null;

  /** @format password */
  password: string;
  deactivateMfa?: boolean;
}

export enum ConvertFunctionEnum {
  None = "none",
  Date = "date",
  Day = "day",
  Month = "month",
  Year = "year",
  Hour = "hour",
  Minute = "minute",
  Second = "second",
}

export interface CorrectionManagerModel {
  /** @format uuid */
  categoryId?: string;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface CorrectionManagerModelApiResultSuccess {
  returnValue?: CorrectionManagerModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface CorrectionManagerModelIEnumerableApiResultSuccess {
  returnValue?: CorrectionManagerModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface DepartmentModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface DepartmentModelApiResultSuccess {
  returnValue?: DepartmentModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface DepartmentModelIEnumerableApiResultSuccess {
  returnValue?: DepartmentModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum EscalationTypeEnum {
  NoEscalation = "NoEscalation",
  OptionalEscalation = "OptionalEscalation",
  RequiredEscalation = "RequiredEscalation",
}

export interface FileDownloadModel {
  filename?: string | null;
  contentType?: string | null;
  base64?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FileDownloadModelApiResultSuccess {
  returnValue?: FileDownloadModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FileModel {
  /** @format uuid */
  ownerId?: string | null;
  description?: string | null;
  fileName?: string | null;

  /** @format int64 */
  fileSize?: number;
  contentType?: string | null;
  blobName?: string | null;
  thumbnailBlobName?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FileModelApiResultSuccess {
  returnValue?: FileModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FindingBasicModel {
  /** @format uuid */
  responseId?: string;
  response?: ResponseBasicModel;
  description?: string | null;
  cause?: string | null;
  useDefinedManagers?: boolean;

  /** @format int32 */
  sequenceIndex?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FindingFileModel {
  /** @format uuid */
  findingId?: string;

  /** @format uuid */
  fileId?: string;
  file?: FileModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FindingManagerModel {
  /** @format uuid */
  findingId?: string;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FindingModel {
  measures?: MeasureModel[] | null;
  findingManagers?: FindingManagerModel[] | null;
  findingFiles?: FindingFileModel[] | null;

  /** @format uuid */
  responseId?: string;
  response?: ResponseBasicModel;
  description?: string | null;
  cause?: string | null;
  useDefinedManagers?: boolean;

  /** @format int32 */
  sequenceIndex?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface FindingModelApiResultSuccess {
  returnValue?: FindingModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface FindingModelIEnumerableApiResultSuccess {
  returnValue?: FindingModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface GroupBasicModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface GroupByDefinition {
  field?: string | null;
  convert?: ConvertFunctionEnum;
}

export interface GroupByProjectionDefinition {
  field?: string | null;
  aggregation?: ProjectionAggregationEnum;
  outputField?: string | null;
  conditional?: boolean;
  op?: ConditionalQueryOperator;
  comparand?: any;
}

export interface GroupModel {
  groupUsers?: GroupUserModel[] | null;
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface GroupModelApiResultSuccess {
  returnValue?: GroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface GroupModelIEnumerableApiResultSuccess {
  returnValue?: GroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface GrouppedQueryModel {
  groupby?: GroupByDefinition[] | null;
  projections?: GroupByProjectionDefinition[] | null;
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export interface GroupUserModel {
  /** @format uuid */
  groupId?: string;
  group?: GroupBasicModel;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface GroupUserModelApiResultSuccess {
  returnValue?: GroupUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface GroupUserModelIEnumerableApiResultSuccess {
  returnValue?: GroupUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum HttpStatusCode {
  Continue = "Continue",
  SwitchingProtocols = "SwitchingProtocols",
  Processing = "Processing",
  EarlyHints = "EarlyHints",
  OK = "OK",
  Created = "Created",
  Accepted = "Accepted",
  NonAuthoritativeInformation = "NonAuthoritativeInformation",
  NoContent = "NoContent",
  ResetContent = "ResetContent",
  PartialContent = "PartialContent",
  MultiStatus = "MultiStatus",
  AlreadyReported = "AlreadyReported",
  IMUsed = "IMUsed",
  Ambiguous = "Ambiguous",
  Moved = "Moved",
  Redirect = "Redirect",
  RedirectMethod = "RedirectMethod",
  NotModified = "NotModified",
  UseProxy = "UseProxy",
  Unused = "Unused",
  TemporaryRedirect = "TemporaryRedirect",
  PermanentRedirect = "PermanentRedirect",
  BadRequest = "BadRequest",
  Unauthorized = "Unauthorized",
  PaymentRequired = "PaymentRequired",
  Forbidden = "Forbidden",
  NotFound = "NotFound",
  MethodNotAllowed = "MethodNotAllowed",
  NotAcceptable = "NotAcceptable",
  ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
  RequestTimeout = "RequestTimeout",
  Conflict = "Conflict",
  Gone = "Gone",
  LengthRequired = "LengthRequired",
  PreconditionFailed = "PreconditionFailed",
  RequestEntityTooLarge = "RequestEntityTooLarge",
  RequestUriTooLong = "RequestUriTooLong",
  UnsupportedMediaType = "UnsupportedMediaType",
  RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
  ExpectationFailed = "ExpectationFailed",
  MisdirectedRequest = "MisdirectedRequest",
  UnprocessableEntity = "UnprocessableEntity",
  Locked = "Locked",
  FailedDependency = "FailedDependency",
  UpgradeRequired = "UpgradeRequired",
  PreconditionRequired = "PreconditionRequired",
  TooManyRequests = "TooManyRequests",
  RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
  UnavailableForLegalReasons = "UnavailableForLegalReasons",
  InternalServerError = "InternalServerError",
  NotImplemented = "NotImplemented",
  BadGateway = "BadGateway",
  ServiceUnavailable = "ServiceUnavailable",
  GatewayTimeout = "GatewayTimeout",
  HttpVersionNotSupported = "HttpVersionNotSupported",
  VariantAlsoNegotiates = "VariantAlsoNegotiates",
  InsufficientStorage = "InsufficientStorage",
  LoopDetected = "LoopDetected",
  NotExtended = "NotExtended",
  NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export type IActionResult = object;

export interface IdentityError {
  code?: string | null;
  description?: string | null;
}

export interface IdentityResult {
  succeeded?: boolean;
  errors?: IdentityError[] | null;
}

export enum ImplementationStateEnum {
  None = "None",
  New = "New",
  InProgress = "InProgress",
  WaitingForVerification = "WaitingForVerification",
  Verified = "Verified",
}

export interface ImportModel {
  importType?: ImportTypeEnum;

  /** @format uuid */
  fileId?: string;
  file?: FileModel;

  /** @format double */
  progress?: number;

  /** @format date-time */
  finishedTime?: string | null;
  errorMessage?: string | null;
  warningMessage?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ImportModelApiResultSuccess {
  returnValue?: ImportModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ImportModelIEnumerableApiResultSuccess {
  returnValue?: ImportModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ImportTypeEnum {
  Audit = "Audit",
}

export enum JunctionOperator {
  And = "and",
  Or = "or",
}

export interface MeasureFileModel {
  /** @format uuid */
  measureId?: string;

  /** @format uuid */
  fileId?: string;
  file?: FileModel;
  type?: MeasureFileTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum MeasureFileTypeEnum {
  Measure = "Measure",
  Perform = "Perform",
  Verification = "Verification",
}

export interface MeasureModel {
  /** @format uuid */
  findingId?: string;
  finding?: FindingBasicModel;
  measureType?: MeasureTypeEnum;

  /** @format date-time */
  implementUntil?: string | null;

  /** @format uuid */
  implementerUserId?: string | null;
  implementerUser?: TenantUserBaseModel;
  implementationState?: ImplementationStateEnum;
  implementationDescription?: string | null;
  implementationComment?: string | null;

  /** @format date-time */
  implementationTime?: string | null;
  verificationComment?: string | null;

  /** @format uuid */
  verificationUserId?: string | null;
  verificationUser?: TenantUserBaseModel;

  /** @format int32 */
  sequenceIndex?: number | null;

  /** @format double */
  implementationDelayDays?: number | null;
  measureVerificationUsers?: MeasureVerificationUserModel[] | null;
  measureFiles?: MeasureFileModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface MeasureModelApiResultSuccess {
  returnValue?: MeasureModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface MeasureModelIEnumerableApiResultSuccess {
  returnValue?: MeasureModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum MeasureTypeEnum {
  Immediate = "Immediate",
  Corrective = "Corrective",
  Preventive = "Preventive",
}

export interface MeasureVerificationUserModel {
  /** @format uuid */
  measureId?: string;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum MeasureVerificationUserTypeEnum {
  AuditPerformer = "AuditPerformer",
  UserSelect = "UserSelect",
}

export interface NotRatedOptionReasonModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface NotRatedOptionReasonModelApiResultSuccess {
  returnValue?: NotRatedOptionReasonModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface NotRatedOptionReasonModelIEnumerableApiResultSuccess {
  returnValue?: NotRatedOptionReasonModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export type Null = object;

export interface ObjectApiResultSuccess {
  returnValue?: any;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ObjectIEnumerableApiResultSuccess {
  returnValue?: any[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface Operation {
  value?: any;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export enum OpResultStatus {
  None = "none",
  Succeeded = "succeeded",
  Canceled = "canceled",
  Faulted = "faulted",
}

export interface OrderByDefinition {
  field?: string | null;

  /** @format int32 */
  index?: number | null;
  order?: SortOrder;
}

export interface PermissionModel {
  /** @format uuid */
  roleId?: string;
  permissionType?: PermissionTypeEnum;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PermissionModelApiResultSuccess {
  returnValue?: PermissionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PermissionModelIEnumerableApiResultSuccess {
  returnValue?: PermissionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum PermissionTypeEnum {
  Admin = "Admin",
  Audits = "Audits",
  Plan = "Plan",
  EditAllAudits = "EditAllAudits",
  EditOwnedAudit = "EditOwnedAudit",
  PerformAudit = "PerformAudit",
  Response = "Response",
  Findings = "Findings",
  Measures = "Measures",
  MistakeCorrection = "MistakeCorrection",
  AdminGroups = "AdminGroups",
  MeasureVerification = "MeasureVerification",
  PlanItemReview = "PlanItemReview",
  MeasuresAllUsers = "MeasuresAllUsers",
}

export interface PlanItemBasicModel {
  evidenceNumber?: string | null;

  /** @format uuid */
  auditId?: string;
  audit?: AuditBasicModel;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format date-time */
  since?: string;

  /** @format date-time */
  until?: string;

  /** @format date-time */
  time?: string;
  isAnswered?: boolean;

  /** @format date-time */
  answeredTime?: string | null;
  isImplementationClosed?: boolean;

  /** @format date-time */
  implementationClosedTime?: string | null;

  /** @format uuid */
  workplaceId?: string | null;
  workplace?: WorkplaceModel;

  /** @format int32 */
  okCount?: number;

  /** @format int32 */
  okWarningCount?: number | null;

  /** @format int32 */
  nokCount?: number;

  /** @format int32 */
  disagreementCount?: number;

  /** @format int32 */
  scoreZeroCount?: number | null;

  /** @format int32 */
  scoreOneCount?: number | null;

  /** @format int32 */
  scoreTwoCount?: number | null;

  /** @format int32 */
  scoreThreeCount?: number | null;

  /** @format int32 */
  scoreFourCount?: number | null;

  /** @format int32 */
  scoreFiveCount?: number | null;

  /** @format int32 */
  scoreSixCount?: number | null;

  /** @format int32 */
  scoreEightCount?: number | null;

  /** @format int32 */
  scoreTenCount?: number | null;

  /** @format int32 */
  notAnsweredCount?: number | null;

  /** @format int32 */
  scoreValue?: number | null;

  /** @format int32 */
  scoreMaxValue?: number | null;

  /** @format int32 */
  responseCount?: number;
  hasCorrection?: boolean;

  /** @format date-time */
  correctionAssignedTime?: string | null;

  /** @format int32 */
  indexInDay?: number | null;
  isRequestedResponseLock?: boolean | null;
  responseLock?: boolean;
  fullLock?: boolean;
  planItemState?: PlanItemStateEnum;

  /** @format uuid */
  reviewedById?: string | null;
  reviewedBy?: TenantUserBaseModel;

  /** @format date-time */
  reviewedOn?: string | null;
  reviewDeclineReason?: string | null;

  /** @format uuid */
  requestReviewById?: string | null;
  requestReviewBy?: TenantUserBaseModel;

  /** @format date-time */
  requestReviewOn?: string | null;

  /** @format uuid */
  auditTimingId?: string | null;
  auditTiming?: AuditTimingModel;
  classification?: string | null;
  aiDisagreementSummary?: string | null;
  aiIdentifiedCauses?: string | null;
  aiIdentifiedRisks?: string | null;
  aiRecommendations?: string | null;
  aiConclusion?: string | null;
  aiIsReportGenerated?: boolean | null;

  /** @format uuid */
  shiftTypeId?: string | null;
  shiftType?: ShiftTypeModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PlanItemBasicModelIEnumerableApiResultSuccess {
  returnValue?: PlanItemBasicModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PlanItemClassificationModel {
  /** @format uuid */
  planItemId?: string;

  /** @format uuid */
  productGroupId?: string | null;
  classificationValue?: string | null;

  /** @format int32 */
  scoreValue?: number | null;

  /** @format int32 */
  scoreMaxValue?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum PlanItemCloseTypeEnum {
  ByAuditor = "ByAuditor",
  ByReviewer = "ByReviewer",
  ByAuditorOrReviewer = "ByAuditorOrReviewer",
}

export interface PlanItemFindingManagerModel {
  /** @format uuid */
  planItemId?: string;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PlanItemModel {
  isIntructionsConfirmed?: boolean | null;

  /** @format date-time */
  instructionsConfirmedOn?: string | null;

  /** @format uuid */
  correctionManagerId?: string | null;
  correctionManager?: UserBaseModel;
  responses?: ResponseModel[] | null;
  summarizations?: PlanItemSummarizationModel[] | null;
  classifications?: PlanItemClassificationModel[] | null;
  productGroupProcessSteps?: PlanItemProductGroupProcessStepModel[] | null;
  findingManagers?: PlanItemFindingManagerModel[] | null;
  evidenceNumber?: string | null;

  /** @format uuid */
  auditId?: string;
  audit?: AuditBasicModel;

  /** @format uuid */
  tenantUserId?: string;
  tenantUser?: TenantUserBaseModel;

  /** @format date-time */
  since?: string;

  /** @format date-time */
  until?: string;

  /** @format date-time */
  time?: string;
  isAnswered?: boolean;

  /** @format date-time */
  answeredTime?: string | null;
  isImplementationClosed?: boolean;

  /** @format date-time */
  implementationClosedTime?: string | null;

  /** @format uuid */
  workplaceId?: string | null;
  workplace?: WorkplaceModel;

  /** @format int32 */
  okCount?: number;

  /** @format int32 */
  okWarningCount?: number | null;

  /** @format int32 */
  nokCount?: number;

  /** @format int32 */
  disagreementCount?: number;

  /** @format int32 */
  scoreZeroCount?: number | null;

  /** @format int32 */
  scoreOneCount?: number | null;

  /** @format int32 */
  scoreTwoCount?: number | null;

  /** @format int32 */
  scoreThreeCount?: number | null;

  /** @format int32 */
  scoreFourCount?: number | null;

  /** @format int32 */
  scoreFiveCount?: number | null;

  /** @format int32 */
  scoreSixCount?: number | null;

  /** @format int32 */
  scoreEightCount?: number | null;

  /** @format int32 */
  scoreTenCount?: number | null;

  /** @format int32 */
  notAnsweredCount?: number | null;

  /** @format int32 */
  scoreValue?: number | null;

  /** @format int32 */
  scoreMaxValue?: number | null;

  /** @format int32 */
  responseCount?: number;
  hasCorrection?: boolean;

  /** @format date-time */
  correctionAssignedTime?: string | null;

  /** @format int32 */
  indexInDay?: number | null;
  isRequestedResponseLock?: boolean | null;
  responseLock?: boolean;
  fullLock?: boolean;
  planItemState?: PlanItemStateEnum;

  /** @format uuid */
  reviewedById?: string | null;
  reviewedBy?: TenantUserBaseModel;

  /** @format date-time */
  reviewedOn?: string | null;
  reviewDeclineReason?: string | null;

  /** @format uuid */
  requestReviewById?: string | null;
  requestReviewBy?: TenantUserBaseModel;

  /** @format date-time */
  requestReviewOn?: string | null;

  /** @format uuid */
  auditTimingId?: string | null;
  auditTiming?: AuditTimingModel;
  classification?: string | null;
  aiDisagreementSummary?: string | null;
  aiIdentifiedCauses?: string | null;
  aiIdentifiedRisks?: string | null;
  aiRecommendations?: string | null;
  aiConclusion?: string | null;
  aiIsReportGenerated?: boolean | null;

  /** @format uuid */
  shiftTypeId?: string | null;
  shiftType?: ShiftTypeModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PlanItemModelApiResultSuccess {
  returnValue?: PlanItemModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PlanItemModelIEnumerableApiResultSuccess {
  returnValue?: PlanItemModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PlanItemProductGroupProcessStepModel {
  /** @format uuid */
  planItemId?: string;

  /** @format uuid */
  productGroupId?: string;
  productGroup?: ProductGroupModel;

  /** @format uuid */
  processStepId?: string;
  processStep?: ProcessStepModel;

  /** @format int32 */
  position?: number;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum PlanItemStateEnum {
  WaitingToPerform = "WaitingToPerform",
  ClosedWithoutFindings = "ClosedWithoutFindings",
  NeedsToCreateMeasures = "NeedsToCreateMeasures",
  NeedsToPerformMeasures = "NeedsToPerformMeasures",
  NeedsToVerifyMeasures = "NeedsToVerifyMeasures",
  AllMeasuresVerified = "AllMeasuresVerified",
  Closed = "Closed",
  WaitingForApproval = "WaitingForApproval",
  Approved = "Approved",
  Declined = "Declined",
  PerformedWithoutFindings = "PerformedWithoutFindings",
}

export interface PlanItemSummarizationModel {
  identifier?: string | null;

  /** @format int32 */
  rowIndex?: number;
  summarizationType?: SummarizationTypeEnum;

  /** @format uuid */
  planItemId?: string;
  processElement?: string | null;
  processSubElement?: string | null;

  /** @format uuid */
  productGroupId?: string | null;
  productGroup?: ProductGroupModel;

  /** @format uuid */
  processStepId?: string | null;
  processStep?: ProcessStepModel;

  /** @format double */
  value?: number | null;
  isClassificationChange?: boolean | null;
  classificationChangeValue?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PositionModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface PositionModelApiResultSuccess {
  returnValue?: PositionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PositionModelIEnumerableApiResultSuccess {
  returnValue?: PositionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface PredicateDefinition {
  junction?: JunctionOperator;
  field?: string | null;
  op?: QueryOperator;
  comparand?: any;
}

export interface ProcessStepModel {
  /** @format uuid */
  auditId?: string;
  stepNumber?: string | null;
  name?: string | null;

  /** @format int32 */
  position?: number;
  isHidden?: boolean;

  /** @format uuid */
  key?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ProductGroupModel {
  /** @format uuid */
  auditId?: string;
  name?: string | null;

  /** @format int32 */
  position?: number;

  /** @format uuid */
  key?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ProductGroupProcessStepModel {
  /** @format uuid */
  auditId?: string;

  /** @format uuid */
  productGroupId?: string;
  productGroup?: ProductGroupModel;

  /** @format uuid */
  processStepId?: string;
  processStep?: ProcessStepModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum ProjectionAggregationEnum {
  Count = "count",
  Avg = "avg",
  Sum = "sum",
  Min = "min",
  Max = "max",
}

export interface QueryModel {
  predicates?: PredicateDefinition[] | null;
  orderby?: OrderByDefinition[] | null;
}

export enum QueryOperator {
  Eq = "eq",
  Ne = "ne",
  Gt = "gt",
  Gte = "gte",
  Lt = "lt",
  Lte = "lte",
  C = "c",
  Sw = "sw",
  Ew = "ew",
  In = "in",
  Wrap = "wrap",
}

export interface QuestionBasicModel {
  /** @format uuid */
  questionGroupId?: string;
  processElementStep?: string | null;
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  position?: number;
  questionGroup?: QuestionGroupBasicModel;
  description?: string | null;
  disagreementResponse?: string | null;
  isHighRisk?: boolean | null;
  aiGenerated?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionFileModel {
  /** @format uuid */
  questionId?: string;

  /** @format uuid */
  fileId?: string;
  file?: FileModel;

  /** @format int32 */
  position?: number | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionGroupBasicModel {
  /** @format uuid */
  auditId?: string;
  audit?: AuditModel;
  name?: string | null;

  /** @format int32 */
  position?: number;
  processElement?: string | null;
  processElementStep?: string | null;
  aiGenerated?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionGroupExplanationModel {
  /** @format uuid */
  questionGroupId?: string;

  /** @format int32 */
  responseValue?: number;
  explanationDescription?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionGroupModel {
  questions?: QuestionModel[] | null;
  questionGroupExplanations?: QuestionGroupExplanationModel[] | null;

  /** @format uuid */
  auditId?: string;
  audit?: AuditModel;
  name?: string | null;

  /** @format int32 */
  position?: number;
  processElement?: string | null;
  processElementStep?: string | null;
  aiGenerated?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionGroupModelApiResultSuccess {
  returnValue?: QuestionGroupModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface QuestionGroupModelIEnumerableApiResultSuccess {
  returnValue?: QuestionGroupModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface QuestionModel {
  questionFiles?: QuestionFileModel[] | null;

  /** @format uuid */
  questionGroupId?: string;
  processElementStep?: string | null;
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  position?: number;
  questionGroup?: QuestionGroupBasicModel;
  description?: string | null;
  disagreementResponse?: string | null;
  isHighRisk?: boolean | null;
  aiGenerated?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface QuestionModelApiResultSuccess {
  returnValue?: QuestionModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface QuestionModelIEnumerableApiResultSuccess {
  returnValue?: QuestionModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum RepeatFrequencyEnum {
  Week = "Week",
  Month = "Month",
}

export interface ResetPasswordModel {
  /** @format email */
  email: string;
}

export interface ResponseBasicModel {
  planItem?: PlanItemBasicModel;

  /** @format uuid */
  planItemId?: string;

  /** @format uuid */
  questionId?: string;
  question?: QuestionBasicModel;
  hasDisagreement?: boolean | null;
  isOk?: boolean | null;

  /** @format int32 */
  okValue?: number | null;

  /** @format int32 */
  scoreValue?: number | null;
  description?: string | null;
  escalationDescription?: string | null;
  immediateMeasures?: string | null;

  /** @format date-time */
  answeredTime?: string | null;
  hasCorrection?: boolean;
  correctionDescription?: string | null;

  /** @format date-time */
  correctionAssignedTime?: string | null;

  /** @format uuid */
  implementerUserId?: string | null;
  implementerUser?: TenantUserBaseModel;
  implementationState?: ImplementationStateEnum;
  implementationDescription?: string | null;

  /** @format date-time */
  implementationTime?: string | null;
  notRatedReason?: string | null;

  /** @format int32 */
  sequenceIndex?: number | null;

  /** @format uuid */
  processStepId?: string | null;
  processStep?: ProcessStepModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum ResponseDescriptionTypeEnum {
  Category = "Category",
  Audit = "Audit",
  Group = "Group",
}

export interface ResponseFileModel {
  /** @format uuid */
  responseId?: string;

  /** @format uuid */
  fileId?: string;
  file?: FileModel;
  type?: ResponseFileType;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export enum ResponseFileType {
  Response = "Response",
  CorrectiveMeasure = "CorrectiveMeasure",
  CorrectiveMeasureImplementation = "CorrectiveMeasureImplementation",
}

export interface ResponseModel {
  responseFiles?: ResponseFileModel[] | null;
  findings?: FindingModel[] | null;
  planItem?: PlanItemBasicModel;

  /** @format uuid */
  planItemId?: string;

  /** @format uuid */
  questionId?: string;
  question?: QuestionBasicModel;
  hasDisagreement?: boolean | null;
  isOk?: boolean | null;

  /** @format int32 */
  okValue?: number | null;

  /** @format int32 */
  scoreValue?: number | null;
  description?: string | null;
  escalationDescription?: string | null;
  immediateMeasures?: string | null;

  /** @format date-time */
  answeredTime?: string | null;
  hasCorrection?: boolean;
  correctionDescription?: string | null;

  /** @format date-time */
  correctionAssignedTime?: string | null;

  /** @format uuid */
  implementerUserId?: string | null;
  implementerUser?: TenantUserBaseModel;
  implementationState?: ImplementationStateEnum;
  implementationDescription?: string | null;

  /** @format date-time */
  implementationTime?: string | null;
  notRatedReason?: string | null;

  /** @format int32 */
  sequenceIndex?: number | null;

  /** @format uuid */
  processStepId?: string | null;
  processStep?: ProcessStepModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ResponseModelApiResultSuccess {
  returnValue?: ResponseModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ResponseModelIEnumerableApiResultSuccess {
  returnValue?: ResponseModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export enum ResponseTypeEnum {
  OkNok = "OkNok",
  OkNokWarning = "OkNokWarning",
  ScoreZeroToOne = "ScoreZeroToOne",
  ScoreZeroToTwo = "ScoreZeroToTwo",
  ScoreOneToThree = "ScoreOneToThree",
  ScoreZeroToFour = "ScoreZeroToFour",
  ScoreZeroToFive = "ScoreZeroToFive",
  ScoreOneToFive = "ScoreOneToFive",
  VDA63 = "VDA63",
  ScoreZeroToThree = "ScoreZeroToThree",
  ScoreOneToFour = "ScoreOneToFour",
}

export interface ResponseValueModel {
  /** @format uuid */
  categoryId?: string;

  /** @format int32 */
  value?: number;
  color?: string | null;
  escalationType?: EscalationTypeEnum;
  description?: string | null;
  explanationDescription?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ResponseValueModelApiResultSuccess {
  returnValue?: ResponseValueModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ResponseValueModelIEnumerableApiResultSuccess {
  returnValue?: ResponseValueModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface RoleModel {
  name?: string | null;
  permissions?: PermissionModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface RoleModelApiResultSuccess {
  returnValue?: RoleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface RoleModelIEnumerableApiResultSuccess {
  returnValue?: RoleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SetPasswordModel {
  currentPassword: string;
  newPassword: string;
}

export interface ShiftTypeModel {
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface ShiftTypeModelApiResultSuccess {
  returnValue?: ShiftTypeModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface ShiftTypeModelIEnumerableApiResultSuccess {
  returnValue?: ShiftTypeModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SignUpModel {
  /** @format email */
  email: string;

  /** @format password */
  password: string;
  firstName: string;
  lastName: string;
  language: string;
  phoneNumber: string;

  /** @format uuid */
  invitationToken?: string | null;
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

export enum SummarizationTypeEnum {
  Question = "Question",
  ProcessElement = "ProcessElement",
  ProcessSubElement = "ProcessSubElement",
  ProcessStep = "ProcessStep",
  HighRiskQuestion = "HighRiskQuestion",
}

export interface SystemUserModel {
  /** @format uuid */
  userId?: string;
  user?: UserBaseModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface SystemUserModelApiResultSuccess {
  returnValue?: SystemUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface SystemUserModelIEnumerableApiResultSuccess {
  returnValue?: SystemUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantBaseModel {
  name?: string | null;
  domainName?: string | null;
  currency?: string | null;
  timeZone?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantInvitationModel {
  emailAddress?: string | null;
  isActive?: boolean;
  isAccepted?: boolean | null;

  /** @format date-time */
  acceptedOn?: string | null;
  tenant?: TenantBaseModel;
  tenantInvitationRoles?: TenantInvitationRoleModel[] | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantInvitationModelApiResultSuccess {
  returnValue?: TenantInvitationModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantInvitationModelIEnumerableApiResultSuccess {
  returnValue?: TenantInvitationModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantInvitationRoleModel {
  /** @format uuid */
  tenantInvitationId?: string;

  /** @format uuid */
  roleId?: string;
  role?: RoleModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantModel {
  identificationNumber?: string | null;
  address?: string | null;
  vat?: string | null;
  addressStreet?: string | null;
  addressCity?: string | null;
  addressZip?: string | null;

  /** @format double */
  evaluationRepeatEach?: number | null;
  evaluationRepeatFrequency?: RepeatFrequencyEnum;

  /** @format uuid */
  avatar?: string | null;

  /** @format int32 */
  maxUploadFileSize?: number;

  /** @format date-time */
  licenceToDate?: string | null;

  /** @format int32 */
  licenceUserCount?: number | null;
  isEnabledCommentOnOkResponse?: boolean | null;
  isRequiredTwoFactor?: boolean | null;
  imageUploadUseCompression?: boolean | null;

  /** @format double */
  imageUploadMaxFileSize?: number | null;

  /** @format int32 */
  imageUploadMaxResolution?: number | null;

  /** @format double */
  imageUploadQuality?: number | null;
  name?: string | null;
  domainName?: string | null;
  currency?: string | null;
  timeZone?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantModelApiResultSuccess {
  returnValue?: TenantModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantModelIEnumerableApiResultSuccess {
  returnValue?: TenantModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantUserBaseModel {
  tenant?: TenantBaseModel;

  /** @format uuid */
  userId?: string;
  user?: UserModel;

  /** @format uuid */
  positionId?: string | null;
  position?: PositionModel;

  /** @format uuid */
  departmentId?: string | null;
  department?: DepartmentModel;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  iCalIdentifier?: string | null;
  accessAllCategories?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantUserModel {
  userRoles?: UserRoleModel[] | null;
  categories?: CategoryUserModel[] | null;
  tenant?: TenantBaseModel;

  /** @format uuid */
  userId?: string;
  user?: UserModel;

  /** @format uuid */
  positionId?: string | null;
  position?: PositionModel;

  /** @format uuid */
  departmentId?: string | null;
  department?: DepartmentModel;
  isActive?: boolean;
  externalSystemId?: string | null;

  /** @format uuid */
  iCalIdentifier?: string | null;
  accessAllCategories?: boolean | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface TenantUserModelApiResultSuccess {
  returnValue?: TenantUserModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface TenantUserModelIEnumerableApiResultSuccess {
  returnValue?: TenantUserModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserBaseModel {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;
  notifyWeeklyAudits?: boolean | null;
  notifyIdleMeasures?: boolean;
  notifyCorrectionManagerUpdate?: boolean | null;
  notifyCorrectionImplementerUpdate?: boolean | null;
  email?: string | null;

  /** @format date-time */
  registrationDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UserModel {
  language?: string | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;

  /** @format uuid */
  avatar?: string | null;
  notifyWeeklyAudits?: boolean | null;
  notifyIdleMeasures?: boolean;
  notifyCorrectionManagerUpdate?: boolean | null;
  notifyCorrectionImplementerUpdate?: boolean | null;
  email?: string | null;

  /** @format date-time */
  registrationDate?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UserRoleModel {
  /** @format uuid */
  tenantUserId?: string;

  /** @format uuid */
  roleId?: string;
  role?: RoleModel;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface UserRoleModelApiResultSuccess {
  returnValue?: UserRoleModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface UserRoleModelIEnumerableApiResultSuccess {
  returnValue?: UserRoleModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkplaceModel {
  code?: string | null;
  name?: string | null;

  /** @format uuid */
  id?: string;

  /** @format date-time */
  createdAt?: string | null;

  /** @format uuid */
  createdById?: string;

  /** @format uuid */
  tenantId?: string;
  isDeleted?: boolean;
}

export interface WorkplaceModelApiResultSuccess {
  returnValue?: WorkplaceModel;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export interface WorkplaceModelIEnumerableApiResultSuccess {
  returnValue?: WorkplaceModel[] | null;
  version?: string | null;
  operationResult?: OpResultStatus;
  httpStatusCode?: HttpStatusCode;
  innerResult?: ApiResultBase;
  error?: ApiResultException;
  message?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((data, key) => {
        data.append(key, input[key]);
        return data;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = (null as unknown) as T;
      r.error = (null as unknown) as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title AMS API
 * @version 1.0
 * @license MIT (https://opensource.org/licenses/MIT)
 * @contact Support <info@nordelo.cz>
 *
 * A REST API service with Swagger, Swashbuckle, and API versioning.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminDeleteSystemUsers
     * @request DELETE:/api/admin/system-users
     * @secure
     */
    adminDeleteSystemUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminInsertSystemUser
     * @request POST:/api/admin/system-users
     * @secure
     */
    adminInsertSystemUser: (data: SystemUserModel, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserById
     * @request GET:/api/admin/system-users/{id}
     * @secure
     */
    adminGetSystemUserById: (id: string, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminPatchSystemUser
     * @request PATCH:/api/admin/system-users/{id}
     * @secure
     */
    adminPatchSystemUser: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminUpdateSystemUser
     * @request PUT:/api/admin/system-users/{id}
     * @secure
     */
    adminUpdateSystemUser: (id: string, data: SystemUserModel, params: RequestParams = {}) =>
      this.request<SystemUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminAggregationSystemUser
     * @request POST:/api/admin/system-users/aggregation
     * @secure
     */
    adminAggregationSystemUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserGroupped
     * @request POST:/api/admin/system-users/groupped
     * @secure
     */
    adminGetSystemUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminSystemUsers
     * @name AdminGetSystemUserBatch
     * @request POST:/api/admin/system-users/{pageIndex},{pageSize}
     * @secure
     */
    adminGetSystemUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<SystemUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/system-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminGetTenantById
     * @request GET:/api/admin/tenants/{id}
     * @secure
     */
    adminGetTenantById: (id: string, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminPatchTenant
     * @request PATCH:/api/admin/tenants/{id}
     * @secure
     */
    adminPatchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<void, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminUpdateTenant
     * @request PUT:/api/admin/tenants/{id}
     * @secure
     */
    adminUpdateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
      this.request<void, ApiResultFailed | void>({
        path: `/api/admin/tenants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminInsertTenant
     * @request POST:/api/admin/tenants
     * @secure
     */
    adminInsertTenant: (data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenants
     * @name AdminGetTenantBatch
     * @request POST:/api/admin/tenants/{pageIndex},{pageSize}
     * @secure
     */
    adminGetTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenants/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminDeleteTenantUsers
     * @request DELETE:/api/admin/tenant-users
     * @secure
     */
    adminDeleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminInsertTenantUser
     * @request POST:/api/admin/tenant-users
     * @secure
     */
    adminInsertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminGetTenantUserById
     * @request GET:/api/admin/tenant-users/{id}
     * @secure
     */
    adminGetTenantUserById: (id: string, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminUpdateTenantUser
     * @request PUT:/api/admin/tenant-users/{id}
     * @secure
     */
    adminUpdateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminAggregationTenantUser
     * @request POST:/api/admin/tenant-users/aggregation
     * @secure
     */
    adminAggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTenantUsers
     * @name AdminGetTenantUserBatch
     * @request POST:/api/admin/tenant-users/{pageIndex},{pageSize}
     * @secure
     */
    adminGetTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/tenant-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetAdminUserById
     * @request GET:/api/admin/users/{id}
     * @secure
     */
    getAdminUserById: (id: string, params: RequestParams = {}) =>
      this.request<AdminUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUsers
     * @name GetAdminUserBatch
     * @request POST:/api/admin/users/{pageIndex},{pageSize}
     * @secure
     */
    getAdminUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<AdminUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/admin/users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiServiceQueueItems
     * @name GetAiServiceQueueItemById
     * @request GET:/api/ai-service-queue-items/{id}
     * @secure
     */
    getAiServiceQueueItemById: (id: string, params: RequestParams = {}) =>
      this.request<AiServiceQueueItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/ai-service-queue-items/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiServiceQueueItems
     * @name GetAiServiceQueueItemBatch
     * @request POST:/api/ai-service-queue-items/{pageIndex},{pageSize}
     * @secure
     */
    getAiServiceQueueItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<AiServiceQueueItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/ai-service-queue-items/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name DeleteAudits
     * @request DELETE:/api/audits
     * @secure
     */
    deleteAudits: (data: QueryModel, params: RequestParams = {}) =>
      this.request<AuditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name InsertAudit
     * @request POST:/api/audits
     * @secure
     */
    insertAudit: (data: AuditModel, params: RequestParams = {}) =>
      this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name GetAuditById
     * @request GET:/api/audits/{id}
     * @secure
     */
    getAuditById: (id: string, params: RequestParams = {}) =>
      this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name PatchAudit
     * @request PATCH:/api/audits/{id}
     * @secure
     */
    patchAudit: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name UpdateAudit
     * @request PUT:/api/audits/{id}
     * @secure
     */
    updateAudit: (id: string, data: AuditModel, params: RequestParams = {}) =>
      this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name PrintAuditById
     * @request GET:/api/audits/{id}/print
     * @secure
     */
    printAuditById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name AggregationAudit
     * @request POST:/api/audits/aggregation
     * @secure
     */
    aggregationAudit: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name CloneAudit
     * @request POST:/api/audits/clone
     * @secure
     */
    cloneAudit: (data: AuditModel, params: RequestParams = {}) =>
      this.request<AuditModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/clone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name ExportAuditBatch
     * @request POST:/api/audits/{pageIndex},{pageSize}/export
     * @secure
     */
    exportAuditBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name GetAuditGroupped
     * @request POST:/api/audits/groupped
     * @secure
     */
    getAuditGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audits
     * @name GetAuditBatch
     * @request POST:/api/audits/{pageIndex},{pageSize}
     * @secure
     */
    getAuditBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<AuditModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audits/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name DeleteAuditTimings
     * @request DELETE:/api/audit-timings
     * @secure
     */
    deleteAuditTimings: (data: QueryModel, params: RequestParams = {}) =>
      this.request<AuditTimingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name InsertAuditTiming
     * @request POST:/api/audit-timings
     * @secure
     */
    insertAuditTiming: (data: AuditTimingModel, params: RequestParams = {}) =>
      this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name GetAuditTimingById
     * @request GET:/api/audit-timings/{id}
     * @secure
     */
    getAuditTimingById: (id: string, params: RequestParams = {}) =>
      this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name PatchAuditTiming
     * @request PATCH:/api/audit-timings/{id}
     * @secure
     */
    patchAuditTiming: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name UpdateAuditTiming
     * @request PUT:/api/audit-timings/{id}
     * @secure
     */
    updateAuditTiming: (id: string, data: AuditTimingModel, params: RequestParams = {}) =>
      this.request<AuditTimingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name AggregationAuditTiming
     * @request POST:/api/audit-timings/aggregation
     * @secure
     */
    aggregationAuditTiming: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name GetAuditTimingGroupped
     * @request POST:/api/audit-timings/groupped
     * @secure
     */
    getAuditTimingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditTimings
     * @name GetAuditTimingBatch
     * @request POST:/api/audit-timings/{pageIndex},{pageSize}
     * @secure
     */
    getAuditTimingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<AuditTimingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/audit-timings/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AzureActiveDirectory
     * @name AadConnect
     * @request POST:/api/azure-active-directory/connect
     */
    aadConnect: (data: AadConnectRequestModel, params: RequestParams = {}) =>
      this.request<AadConnectResponseModel, any>({
        path: `/api/azure-active-directory/connect`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name DeleteCategories
     * @request DELETE:/api/categories
     * @secure
     */
    deleteCategories: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CategoryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name InsertCategory
     * @request POST:/api/categories
     * @secure
     */
    insertCategory: (data: CategoryModel, params: RequestParams = {}) =>
      this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name GetCategoryById
     * @request GET:/api/categories/{id}
     * @secure
     */
    getCategoryById: (id: string, params: RequestParams = {}) =>
      this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name PatchCategory
     * @request PATCH:/api/categories/{id}
     * @secure
     */
    patchCategory: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name UpdateCategory
     * @request PUT:/api/categories/{id}
     * @secure
     */
    updateCategory: (id: string, data: CategoryModel, params: RequestParams = {}) =>
      this.request<CategoryModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name AggregationCategory
     * @request POST:/api/categories/aggregation
     * @secure
     */
    aggregationCategory: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name GetCategoryGroupped
     * @request POST:/api/categories/groupped
     * @secure
     */
    getCategoryGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name GetCategoryBatch
     * @request POST:/api/categories/{pageIndex},{pageSize}
     * @secure
     */
    getCategoryBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CategoryModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/categories/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name DeleteCategoryUsers
     * @request DELETE:/api/category-users
     * @secure
     */
    deleteCategoryUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CategoryUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name InsertCategoryUser
     * @request POST:/api/category-users
     * @secure
     */
    insertCategoryUser: (data: CategoryUserModel, params: RequestParams = {}) =>
      this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name GetCategoryUserById
     * @request GET:/api/category-users/{id}
     * @secure
     */
    getCategoryUserById: (id: string, params: RequestParams = {}) =>
      this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name PatchCategoryUser
     * @request PATCH:/api/category-users/{id}
     * @secure
     */
    patchCategoryUser: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name UpdateCategoryUser
     * @request PUT:/api/category-users/{id}
     * @secure
     */
    updateCategoryUser: (id: string, data: CategoryUserModel, params: RequestParams = {}) =>
      this.request<CategoryUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name AggregationCategoryUser
     * @request POST:/api/category-users/aggregation
     * @secure
     */
    aggregationCategoryUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name GetCategoryUserGroupped
     * @request POST:/api/category-users/groupped
     * @secure
     */
    getCategoryUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CategoryUsers
     * @name GetCategoryUserBatch
     * @request POST:/api/category-users/{pageIndex},{pageSize}
     * @secure
     */
    getCategoryUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CategoryUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/category-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name DeleteCodebooks
     * @request DELETE:/api/codebooks
     * @secure
     */
    deleteCodebooks: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name InsertCodebook
     * @request POST:/api/codebooks
     * @secure
     */
    insertCodebook: (data: CodebookModel, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookById
     * @request GET:/api/codebooks/{id}
     * @secure
     */
    getCodebookById: (id: string, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name PatchCodebook
     * @request PATCH:/api/codebooks/{id}
     * @secure
     */
    patchCodebook: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name UpdateCodebook
     * @request PUT:/api/codebooks/{id}
     * @secure
     */
    updateCodebook: (id: string, data: CodebookModel, params: RequestParams = {}) =>
      this.request<CodebookModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name AggregationCodebook
     * @request POST:/api/codebooks/aggregation
     * @secure
     */
    aggregationCodebook: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookGroupped
     * @request POST:/api/codebooks/groupped
     * @secure
     */
    getCodebookGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Codebooks
     * @name GetCodebookBatch
     * @request POST:/api/codebooks/{pageIndex},{pageSize}
     * @secure
     */
    getCodebookBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CodebookModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/codebooks/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name DeleteCorrectionManagers
     * @request DELETE:/api/correction-managers
     * @secure
     */
    deleteCorrectionManagers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<CorrectionManagerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name InsertCorrectionManager
     * @request POST:/api/correction-managers
     * @secure
     */
    insertCorrectionManager: (data: CorrectionManagerModel, params: RequestParams = {}) =>
      this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name GetCorrectionManagerById
     * @request GET:/api/correction-managers/{id}
     * @secure
     */
    getCorrectionManagerById: (id: string, params: RequestParams = {}) =>
      this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name PatchCorrectionManager
     * @request PATCH:/api/correction-managers/{id}
     * @secure
     */
    patchCorrectionManager: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name UpdateCorrectionManager
     * @request PUT:/api/correction-managers/{id}
     * @secure
     */
    updateCorrectionManager: (id: string, data: CorrectionManagerModel, params: RequestParams = {}) =>
      this.request<CorrectionManagerModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name AggregationCorrectionManager
     * @request POST:/api/correction-managers/aggregation
     * @secure
     */
    aggregationCorrectionManager: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name GetCorrectionManagerGroupped
     * @request POST:/api/correction-managers/groupped
     * @secure
     */
    getCorrectionManagerGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorrectionManagers
     * @name GetCorrectionManagerBatch
     * @request POST:/api/correction-managers/{pageIndex},{pageSize}
     * @secure
     */
    getCorrectionManagerBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<CorrectionManagerModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/correction-managers/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name DeleteDepartments
     * @request DELETE:/api/departments
     * @secure
     */
    deleteDepartments: (data: QueryModel, params: RequestParams = {}) =>
      this.request<DepartmentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name InsertDepartment
     * @request POST:/api/departments
     * @secure
     */
    insertDepartment: (data: DepartmentModel, params: RequestParams = {}) =>
      this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name GetDepartmentById
     * @request GET:/api/departments/{id}
     * @secure
     */
    getDepartmentById: (id: string, params: RequestParams = {}) =>
      this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name PatchDepartment
     * @request PATCH:/api/departments/{id}
     * @secure
     */
    patchDepartment: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name UpdateDepartment
     * @request PUT:/api/departments/{id}
     * @secure
     */
    updateDepartment: (id: string, data: DepartmentModel, params: RequestParams = {}) =>
      this.request<DepartmentModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name AggregationDepartment
     * @request POST:/api/departments/aggregation
     * @secure
     */
    aggregationDepartment: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name GetDepartmentGroupped
     * @request POST:/api/departments/groupped
     * @secure
     */
    getDepartmentGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Departments
     * @name GetDepartmentBatch
     * @request POST:/api/departments/{pageIndex},{pageSize}
     * @secure
     */
    getDepartmentBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<DepartmentModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/departments/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name DownloadFileById
     * @request GET:/api/files/{id}/download
     * @secure
     */
    downloadFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name DownloadFileThumbnailById
     * @request GET:/api/files/{id}/download-thumbnail
     * @secure
     */
    downloadFileThumbnailById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}/download-thumbnail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name GetFileById
     * @request GET:/api/files/{id}
     * @secure
     */
    getFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name DeleteFindings
     * @request DELETE:/api/findings
     * @secure
     */
    deleteFindings: (data: QueryModel, params: RequestParams = {}) =>
      this.request<FindingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name InsertFinding
     * @request POST:/api/findings
     * @secure
     */
    insertFinding: (data: FindingModel, params: RequestParams = {}) =>
      this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name GetFindingById
     * @request GET:/api/findings/{id}
     * @secure
     */
    getFindingById: (id: string, params: RequestParams = {}) =>
      this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name PatchFinding
     * @request PATCH:/api/findings/{id}
     * @secure
     */
    patchFinding: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name UpdateFinding
     * @request PUT:/api/findings/{id}
     * @secure
     */
    updateFinding: (id: string, data: FindingModel, params: RequestParams = {}) =>
      this.request<FindingModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name AggregationFinding
     * @request POST:/api/findings/aggregation
     * @secure
     */
    aggregationFinding: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name GetFindingGroupped
     * @request POST:/api/findings/groupped
     * @secure
     */
    getFindingGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Findings
     * @name GetFindingBatch
     * @request POST:/api/findings/{pageIndex},{pageSize}
     * @secure
     */
    getFindingBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FindingModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/findings/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name DeleteGroups
     * @request DELETE:/api/groups
     * @secure
     */
    deleteGroups: (data: QueryModel, params: RequestParams = {}) =>
      this.request<GroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name InsertGroup
     * @request POST:/api/groups
     * @secure
     */
    insertGroup: (data: GroupModel, params: RequestParams = {}) =>
      this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupById
     * @request GET:/api/groups/{id}
     * @secure
     */
    getGroupById: (id: string, params: RequestParams = {}) =>
      this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PatchGroup
     * @request PATCH:/api/groups/{id}
     * @secure
     */
    patchGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name UpdateGroup
     * @request PUT:/api/groups/{id}
     * @secure
     */
    updateGroup: (id: string, data: GroupModel, params: RequestParams = {}) =>
      this.request<GroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name AggregationGroup
     * @request POST:/api/groups/aggregation
     * @secure
     */
    aggregationGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupGroupped
     * @request POST:/api/groups/groupped
     * @secure
     */
    getGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupBatch
     * @request POST:/api/groups/{pageIndex},{pageSize}
     * @secure
     */
    getGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<GroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name DeleteGroupUsers
     * @request DELETE:/api/group-users
     * @secure
     */
    deleteGroupUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<GroupUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name InsertGroupUser
     * @request POST:/api/group-users
     * @secure
     */
    insertGroupUser: (data: GroupUserModel, params: RequestParams = {}) =>
      this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name GetGroupUserById
     * @request GET:/api/group-users/{id}
     * @secure
     */
    getGroupUserById: (id: string, params: RequestParams = {}) =>
      this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name PatchGroupUser
     * @request PATCH:/api/group-users/{id}
     * @secure
     */
    patchGroupUser: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name UpdateGroupUser
     * @request PUT:/api/group-users/{id}
     * @secure
     */
    updateGroupUser: (id: string, data: GroupUserModel, params: RequestParams = {}) =>
      this.request<GroupUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name AggregationGroupUser
     * @request POST:/api/group-users/aggregation
     * @secure
     */
    aggregationGroupUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name GetGroupUserGroupped
     * @request POST:/api/group-users/groupped
     * @secure
     */
    getGroupUserGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupUsers
     * @name GetGroupUserBatch
     * @request POST:/api/group-users/{pageIndex},{pageSize}
     * @secure
     */
    getGroupUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<GroupUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/group-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags iCal
     * @name GetCalendar
     * @request GET:/api/ical/{id}
     */
    getCalendar: (id: string, params: RequestParams = {}) =>
      this.request<ObjectApiResultSuccess, ApiResultFailed | void>({
        path: `/api/ical/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name DeleteImports
     * @request DELETE:/api/imports
     * @secure
     */
    deleteImports: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ImportModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name InsertImport
     * @request POST:/api/imports
     * @secure
     */
    insertImport: (data: ImportModel, params: RequestParams = {}) =>
      this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name GetImportById
     * @request GET:/api/imports/{id}
     * @secure
     */
    getImportById: (id: string, params: RequestParams = {}) =>
      this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name PatchImport
     * @request PATCH:/api/imports/{id}
     * @secure
     */
    patchImport: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name UpdateImport
     * @request PUT:/api/imports/{id}
     * @secure
     */
    updateImport: (id: string, data: ImportModel, params: RequestParams = {}) =>
      this.request<ImportModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name AggregationImport
     * @request POST:/api/imports/aggregation
     * @secure
     */
    aggregationImport: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name GetImportGroupped
     * @request POST:/api/imports/groupped
     * @secure
     */
    getImportGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name GetImportBatch
     * @request POST:/api/imports/{pageIndex},{pageSize}
     * @secure
     */
    getImportBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ImportModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/imports/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name ExportIssueBatch
     * @request POST:/api/issues/{pageIndex},{pageSize}/export
     * @secure
     */
    exportIssueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/issues/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateAvatar
     * @request PUT:/api/me/avatar
     * @secure
     */
    updateAvatar: (data: AvatarUploadModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name GetApplicationUser
     * @request GET:/api/me
     * @secure
     */
    getApplicationUser: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name UpdateApplicationUser
     * @request PUT:/api/me
     * @secure
     */
    updateApplicationUser: (data: ApplicationUserModel, params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name GenerateTwoFactorKey
     * @request PUT:/api/me/generate-two-factor-key
     * @secure
     */
    generateTwoFactorKey: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/generate-two-factor-key`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name EnableTwoFactor
     * @request PUT:/api/me/enable-two-factor
     * @secure
     */
    enableTwoFactor: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/enable-two-factor`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name DisableTwoFactor
     * @request PUT:/api/me/disable-two-factor
     * @secure
     */
    disableTwoFactor: (params: RequestParams = {}) =>
      this.request<ApplicationUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/me/disable-two-factor`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name DeleteMeasures
     * @request DELETE:/api/measures
     * @secure
     */
    deleteMeasures: (data: QueryModel, params: RequestParams = {}) =>
      this.request<MeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name InsertMeasure
     * @request POST:/api/measures
     * @secure
     */
    insertMeasure: (data: MeasureModel, params: RequestParams = {}) =>
      this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name GetMeasureById
     * @request GET:/api/measures/{id}
     * @secure
     */
    getMeasureById: (id: string, params: RequestParams = {}) =>
      this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name PatchMeasure
     * @request PATCH:/api/measures/{id}
     * @secure
     */
    patchMeasure: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name UpdateMeasure
     * @request PUT:/api/measures/{id}
     * @secure
     */
    updateMeasure: (id: string, data: MeasureModel, params: RequestParams = {}) =>
      this.request<MeasureModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name AggregationMeasure
     * @request POST:/api/measures/aggregation
     * @secure
     */
    aggregationMeasure: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name ExportMeasureBatch
     * @request POST:/api/measures/{pageIndex},{pageSize}/export
     * @secure
     */
    exportMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name GetMeasureGroupped
     * @request POST:/api/measures/groupped
     * @secure
     */
    getMeasureGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measures
     * @name GetMeasureBatch
     * @request POST:/api/measures/{pageIndex},{pageSize}
     * @secure
     */
    getMeasureBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<MeasureModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/measures/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name DeleteNotRatedOptionReasons
     * @request DELETE:/api/not-rated-option-reasons
     * @secure
     */
    deleteNotRatedOptionReasons: (data: QueryModel, params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name InsertNotRatedOptionReason
     * @request POST:/api/not-rated-option-reasons
     * @secure
     */
    insertNotRatedOptionReason: (data: NotRatedOptionReasonModel, params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name GetNotRatedOptionReasonById
     * @request GET:/api/not-rated-option-reasons/{id}
     * @secure
     */
    getNotRatedOptionReasonById: (id: string, params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name PatchNotRatedOptionReason
     * @request PATCH:/api/not-rated-option-reasons/{id}
     * @secure
     */
    patchNotRatedOptionReason: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name UpdateNotRatedOptionReason
     * @request PUT:/api/not-rated-option-reasons/{id}
     * @secure
     */
    updateNotRatedOptionReason: (id: string, data: NotRatedOptionReasonModel, params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name AggregationNotRatedOptionReason
     * @request POST:/api/not-rated-option-reasons/aggregation
     * @secure
     */
    aggregationNotRatedOptionReason: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name GetNotRatedOptionReasonGroupped
     * @request POST:/api/not-rated-option-reasons/groupped
     * @secure
     */
    getNotRatedOptionReasonGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotRatedOptionReasons
     * @name GetNotRatedOptionReasonBatch
     * @request POST:/api/not-rated-option-reasons/{pageIndex},{pageSize}
     * @secure
     */
    getNotRatedOptionReasonBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<NotRatedOptionReasonModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/not-rated-option-reasons/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OpenAI
     * @name GenerateQuestions
     * @request POST:/api/open-ai/generate-questions/{auditId}
     * @secure
     */
    generateQuestions: (auditId: string, data: AiSuggestQuestionsRequest, params: RequestParams = {}) =>
      this.request<AiSuggestQuestionsResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/open-ai/generate-questions/${auditId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OpenAI
     * @name ImproveQuestions
     * @request POST:/api/open-ai/improve-questions/{auditId}
     * @secure
     */
    improveQuestions: (auditId: string, data: AiSuggestQuestionsRequest, params: RequestParams = {}) =>
      this.request<AiSuggestQuestionsResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/open-ai/improve-questions/${auditId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name DeletePermissions
     * @request DELETE:/api/permissions
     * @secure
     */
    deletePermissions: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PermissionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name InsertPermission
     * @request POST:/api/permissions
     * @secure
     */
    insertPermission: (data: PermissionModel, params: RequestParams = {}) =>
      this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionById
     * @request GET:/api/permissions/{id}
     * @secure
     */
    getPermissionById: (id: string, params: RequestParams = {}) =>
      this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PatchPermission
     * @request PATCH:/api/permissions/{id}
     * @secure
     */
    patchPermission: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name UpdatePermission
     * @request PUT:/api/permissions/{id}
     * @secure
     */
    updatePermission: (id: string, data: PermissionModel, params: RequestParams = {}) =>
      this.request<PermissionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name AggregationPermission
     * @request POST:/api/permissions/aggregation
     * @secure
     */
    aggregationPermission: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionGroupped
     * @request POST:/api/permissions/groupped
     * @secure
     */
    getPermissionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionBatch
     * @request POST:/api/permissions/{pageIndex},{pageSize}
     * @secure
     */
    getPermissionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PermissionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/permissions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name DeletePlanItems
     * @request DELETE:/api/plan-items
     * @secure
     */
    deletePlanItems: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name InsertPlanItem
     * @request POST:/api/plan-items
     * @secure
     */
    insertPlanItem: (data: PlanItemModel, params: RequestParams = {}) =>
      this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name GetPlanItemById
     * @request GET:/api/plan-items/{id}
     * @secure
     */
    getPlanItemById: (id: string, params: RequestParams = {}) =>
      this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name PatchPlanItem
     * @request PATCH:/api/plan-items/{id}
     * @secure
     */
    patchPlanItem: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name UpdatePlanItem
     * @request PUT:/api/plan-items/{id}
     * @secure
     */
    updatePlanItem: (id: string, data: PlanItemModel, params: RequestParams = {}) =>
      this.request<PlanItemModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name PrintPlanItemById
     * @request GET:/api/plan-items/{id}/print
     * @secure
     */
    printPlanItemById: (id: string, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name AggregationPlanItem
     * @request POST:/api/plan-items/aggregation
     * @secure
     */
    aggregationPlanItem: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name ExportPlanItemBatch
     * @request POST:/api/plan-items/{pageIndex},{pageSize}/export
     * @secure
     */
    exportPlanItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name GetPlanItemGroupped
     * @request POST:/api/plan-items/groupped
     * @secure
     */
    getPlanItemGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name GetPlanItemBasicBatch
     * @request POST:/api/plan-items/{pageIndex},{pageSize}/basic
     * @secure
     */
    getPlanItemBasicBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PlanItemBasicModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${pageIndex},${pageSize}/basic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlanItems
     * @name GetPlanItemBatch
     * @request POST:/api/plan-items/{pageIndex},{pageSize}
     * @secure
     */
    getPlanItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PlanItemModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/plan-items/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name DeletePositions
     * @request DELETE:/api/positions
     * @secure
     */
    deletePositions: (data: QueryModel, params: RequestParams = {}) =>
      this.request<PositionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name InsertPosition
     * @request POST:/api/positions
     * @secure
     */
    insertPosition: (data: PositionModel, params: RequestParams = {}) =>
      this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name GetPositionById
     * @request GET:/api/positions/{id}
     * @secure
     */
    getPositionById: (id: string, params: RequestParams = {}) =>
      this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name PatchPosition
     * @request PATCH:/api/positions/{id}
     * @secure
     */
    patchPosition: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name UpdatePosition
     * @request PUT:/api/positions/{id}
     * @secure
     */
    updatePosition: (id: string, data: PositionModel, params: RequestParams = {}) =>
      this.request<PositionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name AggregationPosition
     * @request POST:/api/positions/aggregation
     * @secure
     */
    aggregationPosition: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name GetPositionGroupped
     * @request POST:/api/positions/groupped
     * @secure
     */
    getPositionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Positions
     * @name GetPositionBatch
     * @request POST:/api/positions/{pageIndex},{pageSize}
     * @secure
     */
    getPositionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<PositionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/positions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicFiles
     * @name DownloadPublicFileById
     * @request GET:/api/public-files/{id}/download
     * @secure
     */
    downloadPublicFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/public-files/${id}/download`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicFiles
     * @name GetPublicFileById
     * @request GET:/api/public-files/{id}
     * @secure
     */
    getPublicFileById: (id: string, params: RequestParams = {}) =>
      this.request<FileModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/public-files/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name DeleteQuestionGroups
     * @request DELETE:/api/question-groups
     * @secure
     */
    deleteQuestionGroups: (data: QueryModel, params: RequestParams = {}) =>
      this.request<QuestionGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name InsertQuestionGroup
     * @request POST:/api/question-groups
     * @secure
     */
    insertQuestionGroup: (data: QuestionGroupModel, params: RequestParams = {}) =>
      this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name GetQuestionGroupById
     * @request GET:/api/question-groups/{id}
     * @secure
     */
    getQuestionGroupById: (id: string, params: RequestParams = {}) =>
      this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name PatchQuestionGroup
     * @request PATCH:/api/question-groups/{id}
     * @secure
     */
    patchQuestionGroup: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name UpdateQuestionGroup
     * @request PUT:/api/question-groups/{id}
     * @secure
     */
    updateQuestionGroup: (id: string, data: QuestionGroupModel, params: RequestParams = {}) =>
      this.request<QuestionGroupModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name AggregationQuestionGroup
     * @request POST:/api/question-groups/aggregation
     * @secure
     */
    aggregationQuestionGroup: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name GetQuestionGroupGroupped
     * @request POST:/api/question-groups/groupped
     * @secure
     */
    getQuestionGroupGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionGroups
     * @name GetQuestionGroupBatch
     * @request POST:/api/question-groups/{pageIndex},{pageSize}
     * @secure
     */
    getQuestionGroupBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<QuestionGroupModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/question-groups/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name DeleteQuestions
     * @request DELETE:/api/questions
     * @secure
     */
    deleteQuestions: (data: QueryModel, params: RequestParams = {}) =>
      this.request<QuestionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name InsertQuestion
     * @request POST:/api/questions
     * @secure
     */
    insertQuestion: (data: QuestionModel, params: RequestParams = {}) =>
      this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name GetQuestionById
     * @request GET:/api/questions/{id}
     * @secure
     */
    getQuestionById: (id: string, params: RequestParams = {}) =>
      this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name PatchQuestion
     * @request PATCH:/api/questions/{id}
     * @secure
     */
    patchQuestion: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name UpdateQuestion
     * @request PUT:/api/questions/{id}
     * @secure
     */
    updateQuestion: (id: string, data: QuestionModel, params: RequestParams = {}) =>
      this.request<QuestionModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name AggregationQuestion
     * @request POST:/api/questions/aggregation
     * @secure
     */
    aggregationQuestion: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name GetQuestionGroupped
     * @request POST:/api/questions/groupped
     * @secure
     */
    getQuestionGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questions
     * @name GetQuestionBatch
     * @request POST:/api/questions/{pageIndex},{pageSize}
     * @secure
     */
    getQuestionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<QuestionModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/questions/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RawItems
     * @name ExportRawItemBatch
     * @request POST:/api/raw-items/{pageIndex},{pageSize}/export
     * @secure
     */
    exportRawItemBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/raw-items/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ResetPassword
     * @request POST:/api/reset-password
     */
    resetPassword: (data: ResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResetPassword
     * @name ConfirmResetPassword
     * @request POST:/api/reset-password/confirm
     */
    confirmResetPassword: (data: ConfirmResetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/reset-password/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name DeleteResponses
     * @request DELETE:/api/responses
     * @secure
     */
    deleteResponses: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ResponseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name InsertResponse
     * @request POST:/api/responses
     * @secure
     */
    insertResponse: (data: ResponseModel, params: RequestParams = {}) =>
      this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name GetResponseById
     * @request GET:/api/responses/{id}
     * @secure
     */
    getResponseById: (id: string, params: RequestParams = {}) =>
      this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name PatchResponse
     * @request PATCH:/api/responses/{id}
     * @secure
     */
    patchResponse: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name UpdateResponse
     * @request PUT:/api/responses/{id}
     * @secure
     */
    updateResponse: (id: string, data: ResponseModel, params: RequestParams = {}) =>
      this.request<ResponseModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name AggregationResponse
     * @request POST:/api/responses/aggregation
     * @secure
     */
    aggregationResponse: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name ExportResponseBatch
     * @request POST:/api/responses/{pageIndex},{pageSize}/export
     * @secure
     */
    exportResponseBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name GetResponseGroupped
     * @request POST:/api/responses/groupped
     * @secure
     */
    getResponseGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Responses
     * @name GetResponseBatch
     * @request POST:/api/responses/{pageIndex},{pageSize}
     * @secure
     */
    getResponseBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ResponseModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/responses/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name DeleteResponseValues
     * @request DELETE:/api/response-values
     * @secure
     */
    deleteResponseValues: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ResponseValueModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name InsertResponseValue
     * @request POST:/api/response-values
     * @secure
     */
    insertResponseValue: (data: ResponseValueModel, params: RequestParams = {}) =>
      this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name GetResponseValueById
     * @request GET:/api/response-values/{id}
     * @secure
     */
    getResponseValueById: (id: string, params: RequestParams = {}) =>
      this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name PatchResponseValue
     * @request PATCH:/api/response-values/{id}
     * @secure
     */
    patchResponseValue: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name UpdateResponseValue
     * @request PUT:/api/response-values/{id}
     * @secure
     */
    updateResponseValue: (id: string, data: ResponseValueModel, params: RequestParams = {}) =>
      this.request<ResponseValueModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name AggregationResponseValue
     * @request POST:/api/response-values/aggregation
     * @secure
     */
    aggregationResponseValue: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name GetResponseValueGroupped
     * @request POST:/api/response-values/groupped
     * @secure
     */
    getResponseValueGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResponseValues
     * @name GetResponseValueBatch
     * @request POST:/api/response-values/{pageIndex},{pageSize}
     * @secure
     */
    getResponseValueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ResponseValueModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/response-values/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name DeleteRoles
     * @request DELETE:/api/roles
     * @secure
     */
    deleteRoles: (data: QueryModel, params: RequestParams = {}) =>
      this.request<RoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name InsertRole
     * @request POST:/api/roles
     * @secure
     */
    insertRole: (data: RoleModel, params: RequestParams = {}) =>
      this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name GetRoleById
     * @request GET:/api/roles/{id}
     * @secure
     */
    getRoleById: (id: string, params: RequestParams = {}) =>
      this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name PatchRole
     * @request PATCH:/api/roles/{id}
     * @secure
     */
    patchRole: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name UpdateRole
     * @request PUT:/api/roles/{id}
     * @secure
     */
    updateRole: (id: string, data: RoleModel, params: RequestParams = {}) =>
      this.request<RoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name AggregationRole
     * @request POST:/api/roles/aggregation
     * @secure
     */
    aggregationRole: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name GetRoleGroupped
     * @request POST:/api/roles/groupped
     * @secure
     */
    getRoleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name GetRoleBatch
     * @request POST:/api/roles/{pageIndex},{pageSize}
     * @secure
     */
    getRoleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<RoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/roles/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SetPassword
     * @name SetPassword
     * @request POST:/api/set-password
     * @secure
     */
    setPassword: (data: SetPasswordModel, params: RequestParams = {}) =>
      this.request<IdentityResult, void>({
        path: `/api/set-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name DeleteShiftTypes
     * @request DELETE:/api/shift-types
     * @secure
     */
    deleteShiftTypes: (data: QueryModel, params: RequestParams = {}) =>
      this.request<ShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name InsertShiftType
     * @request POST:/api/shift-types
     * @secure
     */
    insertShiftType: (data: ShiftTypeModel, params: RequestParams = {}) =>
      this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name GetShiftTypeById
     * @request GET:/api/shift-types/{id}
     * @secure
     */
    getShiftTypeById: (id: string, params: RequestParams = {}) =>
      this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name PatchShiftType
     * @request PATCH:/api/shift-types/{id}
     * @secure
     */
    patchShiftType: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name UpdateShiftType
     * @request PUT:/api/shift-types/{id}
     * @secure
     */
    updateShiftType: (id: string, data: ShiftTypeModel, params: RequestParams = {}) =>
      this.request<ShiftTypeModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name AggregationShiftType
     * @request POST:/api/shift-types/aggregation
     * @secure
     */
    aggregationShiftType: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name GetShiftTypeGroupped
     * @request POST:/api/shift-types/groupped
     * @secure
     */
    getShiftTypeGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftTypes
     * @name GetShiftTypeBatch
     * @request POST:/api/shift-types/{pageIndex},{pageSize}
     * @secure
     */
    getShiftTypeBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<ShiftTypeModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/shift-types/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignOut
     * @name SignOut
     * @request POST:/api/sign-out
     */
    signOut: (params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-out`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignUp
     * @name SignUp
     * @request POST:/api/sign-up
     */
    signUp: (data: SignUpModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-up`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SignUp
     * @name ActivateAccount
     * @request POST:/api/sign-up/confirm
     */
    activateAccount: (data: ConfirmEmailModel, params: RequestParams = {}) =>
      this.request<IdentityResult, any>({
        path: `/api/sign-up/confirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SolvedIssues
     * @name ExportSolvedIssueBatch
     * @request POST:/api/solved-issues/{pageIndex},{pageSize}/export
     * @secure
     */
    exportSolvedIssueBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/solved-issues/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name DeleteTenantConnection
     * @request DELETE:/api/tenant-connections
     * @secure
     */
    deleteTenantConnection: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name InsertTenantConnection
     * @request POST:/api/tenant-connections
     * @secure
     */
    insertTenantConnection: (data: TenantInvitationModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantConnections
     * @name GetTenantConnectionBatch
     * @request POST:/api/tenant-connections/{pageIndex},{pageSize}
     * @secure
     */
    getTenantConnectionBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-connections/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name DeleteTenantInvitations
     * @request DELETE:/api/tenant-invitations
     * @secure
     */
    deleteTenantInvitations: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name DeleteTenantClientInvitations
     * @request DELETE:/api/tenant-invitations/client
     * @secure
     */
    deleteTenantClientInvitations: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/client`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name GetTenantInvitationById
     * @request GET:/api/tenant-invitations/{id}
     * @secure
     */
    getTenantInvitationById: (id: string, params: RequestParams = {}) =>
      this.request<TenantInvitationModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantInvitations
     * @name GetTenantInvitationBatch
     * @request POST:/api/tenant-invitations/{pageIndex},{pageSize}
     * @secure
     */
    getTenantInvitationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantInvitationModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-invitations/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name UpdateTenantAvatar
     * @request PUT:/api/tenants/{id}/avatar
     * @secure
     */
    updateTenantAvatar: (id: string, data: AvatarUploadModel, params: RequestParams = {}) =>
      this.request<AvatarUploadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${id}/avatar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name GetTenantById
     * @request GET:/api/tenants/{id}
     * @secure
     */
    getTenantById: (id: string, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name PatchTenant
     * @request PATCH:/api/tenants/{id}
     * @secure
     */
    patchTenant: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<void, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name UpdateTenant
     * @request PUT:/api/tenants/{id}
     * @secure
     */
    updateTenant: (id: string, data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name InsertTenant
     * @request POST:/api/tenants
     * @secure
     */
    insertTenant: (data: TenantModel, params: RequestParams = {}) =>
      this.request<TenantModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenants
     * @name GetTenantBatch
     * @request POST:/api/tenants/{pageIndex},{pageSize}
     * @secure
     */
    getTenantBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenants/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name DeleteTenantUsers
     * @request DELETE:/api/tenant-users
     * @secure
     */
    deleteTenantUsers: (data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name InsertTenantUser
     * @request POST:/api/tenant-users
     * @secure
     */
    insertTenantUser: (data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name GetTenantUserById
     * @request GET:/api/tenant-users/{id}
     * @secure
     */
    getTenantUserById: (id: string, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name UpdateTenantUser
     * @request PUT:/api/tenant-users/{id}
     * @secure
     */
    updateTenantUser: (id: string, data: TenantUserModel, params: RequestParams = {}) =>
      this.request<TenantUserModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name AggregationTenantUser
     * @request POST:/api/tenant-users/aggregation
     * @secure
     */
    aggregationTenantUser: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TenantUsers
     * @name GetTenantUserBatch
     * @request POST:/api/tenant-users/{pageIndex},{pageSize}
     * @secure
     */
    getTenantUserBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<TenantUserModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/tenant-users/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name DeleteUserRoles
     * @request DELETE:/api/user-roles
     * @secure
     */
    deleteUserRoles: (data: QueryModel, params: RequestParams = {}) =>
      this.request<UserRoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name InsertUserRole
     * @request POST:/api/user-roles
     * @secure
     */
    insertUserRole: (data: UserRoleModel, params: RequestParams = {}) =>
      this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name GetUserRoleById
     * @request GET:/api/user-roles/{id}
     * @secure
     */
    getUserRoleById: (id: string, params: RequestParams = {}) =>
      this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name PatchUserRole
     * @request PATCH:/api/user-roles/{id}
     * @secure
     */
    patchUserRole: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name UpdateUserRole
     * @request PUT:/api/user-roles/{id}
     * @secure
     */
    updateUserRole: (id: string, data: UserRoleModel, params: RequestParams = {}) =>
      this.request<UserRoleModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name AggregationUserRole
     * @request POST:/api/user-roles/aggregation
     * @secure
     */
    aggregationUserRole: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name GetUserRoleGroupped
     * @request POST:/api/user-roles/groupped
     * @secure
     */
    getUserRoleGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRoles
     * @name GetUserRoleBatch
     * @request POST:/api/user-roles/{pageIndex},{pageSize}
     * @secure
     */
    getUserRoleBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<UserRoleModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/user-roles/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Verifications
     * @name ExportVerificationBatch
     * @request POST:/api/verifications/{pageIndex},{pageSize}/export
     * @secure
     */
    exportVerificationBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<FileDownloadModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/verifications/${pageIndex},${pageSize}/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name DeleteWorkplaces
     * @request DELETE:/api/workplaces
     * @secure
     */
    deleteWorkplaces: (data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name InsertWorkplace
     * @request POST:/api/workplaces
     * @secure
     */
    insertWorkplace: (data: WorkplaceModel, params: RequestParams = {}) =>
      this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name GetWorkplaceById
     * @request GET:/api/workplaces/{id}
     * @secure
     */
    getWorkplaceById: (id: string, params: RequestParams = {}) =>
      this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name PatchWorkplace
     * @request PATCH:/api/workplaces/{id}
     * @secure
     */
    patchWorkplace: (id: string, data: Operation[], params: RequestParams = {}) =>
      this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name UpdateWorkplace
     * @request PUT:/api/workplaces/{id}
     * @secure
     */
    updateWorkplace: (id: string, data: WorkplaceModel, params: RequestParams = {}) =>
      this.request<WorkplaceModelApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name AggregationWorkplace
     * @request POST:/api/workplaces/aggregation
     * @secure
     */
    aggregationWorkplace: (data: AggregationModel, params: RequestParams = {}) =>
      this.request<AggregationResponseApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/aggregation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name GetWorkplaceGroupped
     * @request POST:/api/workplaces/groupped
     * @secure
     */
    getWorkplaceGroupped: (data: GrouppedQueryModel, params: RequestParams = {}) =>
      this.request<ObjectIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/groupped`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workplaces
     * @name GetWorkplaceBatch
     * @request POST:/api/workplaces/{pageIndex},{pageSize}
     * @secure
     */
    getWorkplaceBatch: (pageIndex: number, pageSize: number, data: QueryModel, params: RequestParams = {}) =>
      this.request<WorkplaceModelIEnumerableApiResultSuccess, ApiResultFailed | void>({
        path: `/api/workplaces/${pageIndex},${pageSize}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
